import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { ignoreInterceptorHeaders } from '@rx-applications/shared/utils';

@Injectable({ providedIn: 'root' })
export class RequestIdInterceptor implements HttpInterceptor {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.headers.has(ignoreInterceptorHeaders.ignoreRequestId)) {
      const requestClone = req.clone({
        headers: req.headers.delete(ignoreInterceptorHeaders.ignoreRequestId),
      });
      return next.handle(requestClone);
    }

    const requestId = uuidv4();

    const reqClone = req.clone({ setHeaders: { 'Rx-RequestID': requestId } });

    return next.handle(reqClone);
  }
}
